import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import api from "@/lib/api";
import { AuthProvider } from "@/context/AuthContext";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import WhatsAppButton from "@/components/WhatsAppButton";
import Home from "@/pages/Home";
import Services from "@/pages/Services";
import Explore from "@/pages/Explore";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import Booking from "@/pages/Booking";
import RequestQuote from "@/pages/RequestQuote";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import SplitPay from "@/pages/SplitPay";
import PayBalance from "@/pages/PayBalance";
import Invoice from "@/pages/Invoice";
import ManageBooking from "@/pages/ManageBooking";
import ReviewSubmit from "@/pages/ReviewSubmit";
import Reviews from "@/pages/Reviews";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";

function PublicLayout({ children }) {
  return (
    <>
      <Navbar />
      <main>{children}</main>
      <Footer />
      <WhatsAppButton />
    </>
  );
}

function getSessionId() {
  let sid = sessionStorage.getItem("bt_sid");
  if (!sid) {
    sid = Math.random().toString(36).slice(2) + Date.now().toString(36);
    sessionStorage.setItem("bt_sid", sid);
  }
  return sid;
}

function PageTracker() {
  const location = useLocation();
  useEffect(() => {
    if (location.pathname.startsWith("/admin")) return;
    // Owner opt-out: ?notrack=1 flags this device, ?track=1 re-enables
    const qp = new URLSearchParams(window.location.search);
    if (qp.get("notrack") === "1") localStorage.setItem("bt_no_track", "1");
    if (qp.get("track") === "1") localStorage.removeItem("bt_no_track");
    if (localStorage.getItem("bt_no_track") === "1") return;
    api.post("/track", {
      path: location.pathname,
      referrer: document.referrer || "",
      session_id: getSessionId(),
      screen: `${window.screen?.width || 0}x${window.screen?.height || 0}`,
    }).catch(() => {});
  }, [location.pathname]);
  return null;
}

const LIVE_SITE = "https://addistaxiandtour.com";
if (typeof window !== "undefined" && window.location.hostname.includes("preview.emergentagent.com")) {
  if (new URLSearchParams(window.location.search).has("preview")) sessionStorage.setItem("allowPreview", "1");
  if (!sessionStorage.getItem("allowPreview")) window.location.replace(LIVE_SITE + window.location.pathname + window.location.search + window.location.hash);
}

function App() {
  useEffect(() => {
    document.title = "Bridge Taxi, Airport Shuttle & Tours — Halifax, NS";
  }, []);
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <PageTracker />
          <Routes>
            <Route path="/" element={<PublicLayout><Home /></PublicLayout>} />
            <Route path="/services" element={<PublicLayout><Services /></PublicLayout>} />
            <Route path="/explore" element={<PublicLayout><Explore /></PublicLayout>} />
            <Route path="/about" element={<PublicLayout><About /></PublicLayout>} />
            <Route path="/contact" element={<PublicLayout><Contact /></PublicLayout>} />
            <Route path="/book" element={<PublicLayout><Booking /></PublicLayout>} />
            <Route path="/quote" element={<PublicLayout><RequestQuote /></PublicLayout>} />
            <Route path="/payment/success" element={<PublicLayout><PaymentSuccess /></PublicLayout>} />
            <Route path="/payment/cancel" element={<PublicLayout><PaymentCancel /></PublicLayout>} />
            <Route path="/split/:bookingId" element={<PublicLayout><SplitPay /></PublicLayout>} />
            <Route path="/pay/:bookingId" element={<PublicLayout><PayBalance /></PublicLayout>} />
            <Route path="/manage/:id" element={<PublicLayout><ManageBooking /></PublicLayout>} />
            <Route path="/reviews" element={<PublicLayout><Reviews /></PublicLayout>} />
            <Route path="/review" element={<PublicLayout><ReviewSubmit /></PublicLayout>} />
            <Route path="/review/:bookingId" element={<PublicLayout><ReviewSubmit /></PublicLayout>} />
            <Route path="/invoice/:bookingId" element={<Invoice />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminDashboard />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
